<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title"/>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            :height="tableHeight"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'backupCopy'">
                  <span>--</span>
              </section>
              <seciton v-else-if="scope.column.property === 'zero'"><span>0</span></seciton>
              <section v-else>{{scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableSetting from 'components/tableSetting/tableSetting';
import {dZOrderList} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableSetting, // 表格设置
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          // backupCopy zero为目前没有数据的列 处理数据展示
          {prop: 'driverName', label: '司机姓名'},
          {prop: 'plateNumber', label: '车牌号'},
          {prop: 'lineName', label: '线路名称'},
          {prop: 'backupCopy', label: '行驶里程'},
          {prop: 'productName', label: '货物名称'},
          {prop: 'weightNumber', label: '装货磅单号'},
          {prop: 'backupCopy', label: '拉运开运时间'},
          {prop: 'grossWeightDouble', label: '装货毛重'},
          {prop: 'backupCopy', label: '卸货磅单号'},
          {prop: 'backupCopy', label: '卸货时间'},
          {prop: 'backupCopy', label: '卸货毛重'},
          {prop: 'backupCopy', label: '卸货净重'},
          {prop: 'settlementUnitPriceDouble', label: '结算单价'},
          {prop: 'backupCopy', label: '拉运货值'},
          {prop: 'deductions', label: '扣损金额'},
          {prop: 'settlementPrice', label: '结算金额'},
          {prop: 'zero', label: '报销金额'},
          {prop: 'zero', label: '已报销金额'},
          {prop: 'zero', label: '未报销金额'},
          {prop: 'zero', label: '司机劳务费用结算单价'},
          {prop: 'zero', label: '工资支出'},
          {prop: 'zero', label: '加气充电支出'},
          {prop: 'zero', label: 'ETC支出'},
          {prop: 'zero', label: '补轮胎支出'},
          {prop: 'zero', label: '电路类支出'},
          {prop: 'zero', label: '车灯类支出'},
          {prop: 'zero', label: '车辆维修设备换件支出'},
          {prop: 'zero', label: '电焊修补支出'},
          {prop: 'zero', label: '打黄油'},
          {prop: 'zero', label: '换新轮胎支出'},
          {prop: 'zero', label: '柴暖类支出'},
          {prop: 'zero', label: '合计维修费用'},
          {prop: 'zero', label: '融资租赁'},
          {prop: 'zero', label: '电车电池租金'},
          {prop: 'zero', label: '不扣贷款前利润'},
          {prop: 'zero', label: '净利润'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: dZOrderList,
  },
};
</script>

<style scoped lang="scss">
.isTotal{
  color: red
}
</style>
